import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function HomeModal({ button, handler, row, reported, handlerReport }) {
  const [open, setOpen] = React.useState(false);
  const [observation, setObservation] = React.useState('');
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackMessage, setSnackMessage] = React.useState('');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSnackbarClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setSnackOpen(false);
  };

  const handlerFunctionReport = () => {
    const rowWithObservation = { ...row, Observacion: observation };
    handlerReport('1');
    handler(rowWithObservation, 'report');
    handleClose();
    setSnackMessage('Reporte enviado. Pronto llegará el mensaje a la casilla de correo.');
    setSnackOpen(true);
  };

  const handlerFunctionClose = () => {
    const rowWithObservation = { ...row, Observacion: observation };
    handler(rowWithObservation, 'close');
    handleClose();
    setSnackMessage('Pedido cerrado correctamente. La acción puede demorar hasta 1 minuto en reflejarse.');
    setSnackOpen(true);
  };

  const handleChangeObservation = (event) => {
    setObservation(event.target.value);
  };

  return (
    <>
      <IconButton
        aria-label='reportar'
        size='small'
        onClick={handleOpen}
        disabled={reported}
        sx={{
          paddingRight: 0,
          paddingLeft: 0,
          fontSize: 24,
          color: 'red',
          '&:active': { transform: 'scale(0.8)' },
        }}
      >
        {button}
      </IconButton>

      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography variant='h6'>Detalle del reporte</Typography>

          <TextField
            label="Observación"
            multiline
            rows={4}
            variant='outlined'
            fullWidth
            value={observation}
            onChange={handleChangeObservation}
            sx={{ mt: 2 }}
          />

          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button onClick={handleClose} sx={{ mt: 2, mr: 5,
              backgroundColor: '#43BDB4',
              color: 'white',
              '&:hover': { backgroundColor: '#00a884' },
            }}>
              Cancelar
            </Button>

            <Button onClick={handlerFunctionClose} sx={{ mt: 2, mr: 5,
              backgroundColor: '#43BDB4',
              color: 'white',
              '&:hover': { backgroundColor: '#00a884' },
            }}>
              Cerrar pedido
            </Button>

            <Button onClick={handlerFunctionReport} sx={{ mt: 2,
              backgroundColor: '#43BDB4',
              color: 'white',
              '&:hover': { backgroundColor: '#00a884' },
            }}>
              Guardar y reportar
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar open={snackOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
          {snackMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
